import React, { useState, useEffect } from 'react';

// Feature data
const featuresData = [
  {
    id: 1,
    title: "Intuitive Design & Configuration",
    description: "Easily create cloud architectures from scratch or reuse templates to accelerate deployment and standardization.",
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="30px" height="30px" viewBox="0 0 118.000000 118.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,118.000000) scale(0.100000,-0.100000)"
          fill="#FFFFFF" stroke="none">
          <path d="M990 1045 l-44 -45 -426 0 -427 0 -21 -23 c-22 -23 -22 -28 -22 -343
      1 -253 3 -323 14 -337 22 -29 72 -37 238 -37 177 0 174 1 138 -69 -11 -22 -35
      -49 -55 -61 -19 -12 -35 -26 -35 -31 0 -5 87 -9 205 -9 219 0 236 4 173 45
      -38 24 -65 60 -74 98 l-6 27 166 0 c185 0 229 10 246 55 6 15 10 148 10 314
      l0 287 35 34 c19 19 35 43 35 55 0 26 -59 85 -86 85 -11 0 -40 -20 -64 -45z
      m97 -7 c13 -12 23 -26 23 -32 0 -6 -90 -101 -200 -211 l-200 -200 -32 33 -33
      32 200 200 c110 110 204 200 209 200 5 0 20 -10 33 -22z m-187 -75 c0 -4 -65
      -73 -145 -153 -141 -141 -145 -146 -156 -203 -7 -31 -9 -60 -6 -63 3 -3 31 -1
      64 5 58 11 59 13 215 168 114 114 159 153 163 141 3 -8 5 -131 3 -272 -3 -257
      -3 -258 -27 -277 -22 -18 -45 -19 -455 -19 -374 0 -434 2 -454 16 -22 15 -22
      16 -22 328 0 229 3 315 12 324 9 9 114 12 410 12 219 0 398 -3 398 -7z m-242
      -355 c18 -18 15 -28 -8 -28 -13 0 -20 7 -20 20 0 23 10 26 28 8z m-28 -391 c7
      -23 21 -54 32 -69 l19 -28 -125 0 -125 0 25 37 c13 20 27 48 30 62 3 14 7 31
      9 36 1 6 28 9 62 7 l60 -4 13 -41z"/>
          <path d="M120 805 c0 -11 12 -15 48 -15 96 0 142 -55 142 -167 0 -83 21 -131
      70 -156 41 -21 104 -16 133 11 26 24 50 71 43 88 -9 23 -24 16 -31 -16 -9 -40
      -40 -60 -92 -60 -62 0 -83 24 -83 98 -1 110 -24 165 -90 210 -40 27 -140 32
      -140 7z"/>
        </g>
      </svg>
    ),
  },
  {
    id: 2,
    title: "Version Control & Change Management",
    description: "Track changes, commits, and manage infrastructure updates using pull requests for full GitOps compatibility.",
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="30px" height="30px" viewBox="0 0 119.000000 118.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,118.000000) scale(0.100000,-0.100000)"
          fill="#FFFFFF" stroke="none">
          <path d="M78 1143 c-3 -36 -5 -38 -41 -41 l-38 -3 3 -56 c4 -71 28 -87 28 -19
      l0 46 205 0 205 0 0 -119 c0 -66 3 -127 6 -135 6 -15 -14 -16 -202 -14 l-209
      3 -3 63 c-4 83 -26 80 -30 -5 -5 -96 -14 -93 277 -93 199 0 251 3 260 14 8 9
      11 72 9 202 l-3 189 -232 3 -232 2 -3 -37z m440 -165 c-3 -165 -4 -173 -23
      -173 -19 0 -20 8 -23 148 l-3 147 -179 0 -180 0 0 25 0 25 205 0 205 0 -2
      -172z"/>
          <path d="M718 1143 c-3 -36 -5 -38 -40 -41 l-38 -3 0 -153 c0 -105 4 -156 12
      -164 17 -17 141 -16 136 1 -3 7 -28 14 -59 17 l-54 5 -3 133 -3 132 206 0 205
      0 0 -135 0 -135 -104 0 c-57 0 -111 -3 -120 -6 -44 -17 -1 -24 143 -24 133 0
      162 3 176 16 13 14 15 43 13 202 l-3 187 -232 3 -232 2 -3 -37z m437 -168 c0
      -163 -1 -170 -20 -170 -19 0 -20 8 -23 147 l-3 148 -182 2 c-154 3 -182 5
      -183 18 0 8 1 18 4 23 2 4 94 6 205 5 l202 -3 0 -170z"/>
          <path d="M110 1000 c0 -15 41 -124 52 -137 6 -7 14 -10 19 -8 13 8 54 144 46
      152 -11 10 -23 -7 -37 -50 -14 -43 -22 -40 -40 16 -10 33 -40 53 -40 27z"/>
          <path d="M277 1003 c-9 -8 -9 -43 0 -43 3 0 15 7 25 16 16 15 18 15 24 1 3 -9
      -7 -35 -26 -62 -37 -54 -31 -68 24 -63 41 3 53 21 19 26 -28 4 -28 10 -3 42
      22 28 26 60 8 78 -13 13 -60 16 -71 5z"/>
          <path d="M750 1002 c0 -4 10 -37 22 -73 21 -64 36 -85 50 -71 10 10 48 121 48
      139 0 28 -23 6 -40 -37 l-18 -45 -16 39 c-9 21 -16 42 -16 47 0 5 -7 9 -15 9
      -8 0 -15 -4 -15 -8z"/>
          <path d="M922 998 c-6 -6 -12 -18 -12 -25 0 -18 27 -16 34 3 3 8 10 12 16 9
      15 -10 12 -35 -5 -35 -8 0 -15 -5 -15 -10 0 -6 7 -13 15 -16 17 -7 20 -34 4
      -34 -7 0 -18 8 -25 18 -12 16 -13 16 -19 -1 -15 -36 47 -65 73 -34 6 7 10 40
      9 72 -2 59 -3 60 -32 63 -17 2 -36 -3 -43 -10z"/>
          <path d="M221 696 c-24 -25 -21 -49 4 -39 12 4 15 -4 15 -39 0 -74 11 -78 189
      -78 l152 0 -3 -62 -3 -63 -87 -3 -88 -3 0 -34 c0 -32 -2 -34 -37 -37 l-38 -3
      -3 -68 c-2 -55 0 -67 13 -67 12 0 15 12 15 55 l0 55 205 0 205 0 0 -140 0
      -140 -192 0 c-106 0 -198 4 -205 8 -6 4 -13 30 -15 57 -4 66 -22 64 -26 -2 -2
      -42 1 -56 17 -72 20 -20 32 -21 256 -21 222 0 236 1 255 20 19 19 20 33 20
      205 l0 184 -127 3 -128 3 -3 63 -3 62 144 0 c166 0 177 5 177 79 0 34 3 42 15
      38 8 -4 17 -1 21 4 7 12 -34 59 -51 59 -17 0 -58 -47 -51 -59 4 -5 14 -7 22
      -4 13 5 15 -2 12 -38 l-3 -44 -310 0 -310 0 -3 44 c-3 36 -1 43 12 38 8 -3 18
      -1 22 4 7 12 -34 59 -51 59 -6 0 -22 -11 -34 -24z m619 -485 c0 -134 -3 -170
      -14 -174 -30 -12 -36 16 -36 160 l0 143 -180 0 c-173 0 -180 1 -180 20 0 19 7
      20 205 20 l205 0 0 -169z"/>
          <path d="M450 243 c0 -28 49 -148 61 -151 15 -3 59 103 59 141 0 31 -23 13
      -39 -31 -8 -23 -18 -42 -21 -42 -3 0 -12 19 -20 42 -13 37 -40 64 -40 41z"/>
          <path d="M610 237 c0 -8 7 -17 15 -21 11 -4 15 -21 15 -67 0 -44 3 -60 13 -56
      8 2 12 27 12 78 0 73 0 74 -27 77 -19 2 -28 -1 -28 -11z"/>
        </g>
      </svg>
    ),
  },
  {
    id: 3,
    title: "Integrated Security & Access Control",
    description: "Automated security checks and RBAC-based access control to ensure compliance and prevent misconfigurations.",
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="30px" height="30px" viewBox="0 0 118.000000 118.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,118.000000) scale(0.100000,-0.100000)"
          fill="#FFFFFF" stroke="none">
          <path d="M475 1165 c-84 -18 -115 -32 -115 -50 0 -19 22 -19 85 1 69 22 214
      22 290 0 33 -10 89 -33 124 -52 49 -27 66 -32 72 -22 12 19 -14 42 -90 77
      -124 57 -247 73 -366 46z"/>
          <path d="M123 1044 c-22 -22 -25 -32 -20 -67 5 -35 -1 -55 -34 -122 -90 -182
      -89 -349 1 -532 122 -248 420 -376 685 -295 39 11 61 24 63 35 4 21 -17 22
      -83 1 -69 -22 -214 -22 -290 0 -128 37 -231 113 -305 223 -78 117 -110 251
      -90 376 12 79 41 161 73 209 19 28 28 32 55 30 43 -5 92 42 92 88 0 72 -94
      107 -147 54z m99 -40 c11 -23 10 -29 -11 -45 -39 -31 -85 6 -61 50 16 31 57
      28 72 -5z"/>
          <path d="M986 1003 c-12 -12 -6 -33 9 -33 8 0 15 6 15 14 0 17 -14 28 -24 19z" />
          <path d="M545 981 c-41 -10 -86 -35 -107 -58 -28 -31 -58 -106 -58 -147 0 -26
      -8 -48 -25 -68 -25 -29 -25 -32 -25 -209 0 -246 -19 -229 260 -229 279 0 260
      -17 260 229 0 177 0 180 -25 209 -17 20 -25 42 -25 68 0 41 -30 116 -58 147
      -40 45 -137 73 -197 58z m148 -74 c63 -48 90 -168 40 -175 -19 -3 -23 1 -23
      23 0 71 -57 135 -120 135 -63 0 -120 -64 -120 -135 0 -22 -4 -26 -22 -23 -30
      4 -35 46 -13 103 28 74 82 108 167 102 42 -2 65 -10 91 -30z m-55 -77 c16 -15
      22 -33 22 -60 l0 -40 -70 0 -70 0 0 40 c0 46 29 80 70 80 14 0 36 -9 48 -20z
      m160 -152 c17 -17 17 -339 0 -356 -17 -17 -399 -17 -416 0 -17 17 -17 339 0
      356 17 17 399 17 416 0z"/>
          <path d="M547 629 c-22 -13 -50 -75 -41 -90 3 -6 10 -41 14 -77 12 -93 56
      -127 110 -84 16 13 23 34 30 88 5 39 10 75 11 80 12 65 -66 116 -124 83z m66
      -41 c14 -11 16 -25 10 -86 -3 -40 -12 -80 -19 -90 -13 -16 -15 -16 -29 2 -8
      11 -15 40 -15 64 0 24 -5 52 -10 62 -8 15 -6 24 10 40 23 23 30 24 53 8z"/>
          <path d="M1045 920 c-4 -7 5 -33 19 -60 96 -176 93 -403 -7 -552 -19 -28 -28
      -32 -55 -30 -43 5 -92 -42 -92 -88 0 -72 94 -107 147 -54 22 22 25 32 20 67
      -5 35 1 55 34 122 90 183 87 377 -9 549 -28 52 -45 65 -57 46z m-9 -715 c9
      -23 -15 -55 -42 -55 -17 0 -28 8 -36 26 -11 23 -10 29 11 45 18 15 27 16 42 8
      11 -6 22 -16 25 -24z"/>
        </g>
      </svg>
    ),
  },
  {
    id: 4,
    title: "Multicloud Automation",
    description: "Manage infrastructure across AWS and Azure from a single platform, streamlining operations and reducing complexity.",
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="30px" height="30px" viewBox="0 0 118.000000 118.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,118.000000) scale(0.100000,-0.100000)"
          fill="#FFFFFF" stroke="none">
          <path d="M485 991 c-102 -25 -175 -104 -211 -228 -2 -8 -22 -13 -52 -13 -153
      0 -214 -201 -89 -294 24 -18 46 -22 133 -24 l104 -4 0 -59 c0 -76 -16 -85 -63
      -35 -27 29 -42 36 -71 36 -69 0 -113 -72 -82 -136 29 -62 102 -72 150 -21 17
      19 43 37 56 40 49 13 55 23 60 99 5 72 5 73 35 76 35 4 49 21 33 39 -8 9 -49
      13 -150 13 -160 0 -187 9 -212 71 -20 49 -6 101 35 130 29 20 55 22 133 7 16
      -2 21 6 31 52 15 73 36 111 85 152 117 101 293 62 357 -78 13 -30 28 -56 33
      -59 5 -3 21 2 36 12 34 22 109 22 151 0 96 -50 101 -193 10 -261 -25 -19 -44
      -21 -177 -24 -116 -3 -151 -7 -161 -18 -15 -18 -3 -31 31 -36 24 -3 25 -7 28
      -70 3 -59 6 -70 29 -88 14 -11 33 -20 41 -20 9 0 28 -15 43 -33 23 -28 33 -32
      74 -32 39 0 51 5 71 28 53 62 10 157 -72 157 -29 0 -43 -7 -71 -36 -47 -50
      -63 -41 -63 36 l0 60 95 0 c68 0 105 5 128 16 132 67 163 228 63 328 -60 60
      -143 79 -219 50 -7 -2 -21 12 -32 32 -57 106 -196 165 -320 135z m-217 -683
      c27 -27 4 -78 -37 -78 -14 0 -41 29 -41 45 0 35 53 58 78 33z m666 -4 c9 -8
      16 -22 16 -29 0 -18 -27 -45 -45 -45 -18 0 -45 27 -45 45 0 18 27 45 45 45 7
      0 21 -7 29 -16z"/>
          <path d="M534 740 c-33 -13 -54 -50 -54 -93 0 -32 6 -45 35 -71 35 -32 35 -33
        35 -116 0 -83 0 -83 -36 -114 -30 -26 -36 -38 -36 -71 0 -93 129 -130 172 -49
        25 47 9 117 -30 129 -18 6 -20 15 -20 105 0 90 2 100 21 110 11 7 27 27 35 46
        12 29 12 39 1 67 -8 17 -21 38 -29 44 -21 18 -69 24 -94 13z m76 -70 c21 -40
        -17 -72 -64 -54 -16 6 -22 54 -9 67 15 15 63 7 73 -13z m-6 -372 c13 -19 14
        -25 2 -43 -26 -39 -76 -26 -76 19 0 46 48 62 74 24z"/>
        </g>
      </svg>
    ),
  },
  {
    id: 5,
    title: "Cost Optimization & Monitoring",
    description: "Visualize and monitor real-time cloud costs to prevent overspending and optimize resource usage effectively.",
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="30px" height="30px" viewBox="0 0 119.000000 118.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,118.000000) scale(0.100000,-0.100000)"
          fill="#FFFFFF" stroke="none">
          <path d="M365 1029 c-131 -27 -256 -122 -314 -241 -178 -360 172 -750 554
      -618 62 21 98 42 142 84 18 16 34 28 36 25 27 -36 122 -139 127 -137 16 6 280
      324 277 333 -2 6 -31 11 -65 13 l-62 3 0 198 c0 172 -2 200 -16 205 -9 3 -73
      6 -143 6 -118 0 -129 2 -147 21 -74 84 -258 134 -389 108z m148 -29 c70 -11
      154 -48 208 -91 35 -28 39 -35 39 -77 l0 -46 -46 48 c-54 57 -147 103 -224
      112 -116 13 -255 -48 -325 -144 -152 -207 -47 -494 205 -558 108 -27 224 0
      320 76 l38 30 16 -24 c15 -24 14 -26 -23 -55 -55 -44 -139 -80 -211 -92 -170
      -27 -356 74 -436 236 -27 56 -29 68 -29 175 0 107 2 119 29 175 56 115 171
      204 296 231 70 16 74 16 143 4z m85 -119 c55 -28 129 -101 148 -146 9 -22 14
      -71 14 -140 l0 -105 -60 0 c-77 0 -85 -15 -36 -72 l36 -42 -20 -22 c-12 -12
      -44 -34 -73 -50 -48 -27 -61 -29 -152 -29 -86 0 -106 3 -145 24 -61 32 -116
      86 -148 146 -24 44 -27 61 -27 145 0 108 17 154 84 223 68 73 135 97 251 94
      64 -3 95 -9 128 -26z m424 -218 l3 -208 52 -5 53 -5 -107 -125 c-58 -69 -109
      -126 -113 -128 -7 -3 -220 241 -220 252 0 3 21 6 48 8 l47 3 3 195 c1 107 4
      201 7 208 3 8 36 12 114 12 l111 0 2 -207z"/>
          <path d="M440 805 c0 -19 -8 -28 -34 -39 -88 -37 -88 -145 0 -182 34 -14 34
      -15 34 -79 0 -47 -4 -65 -13 -65 -19 0 -57 43 -57 63 0 9 -7 17 -15 17 -20 0
      -19 -39 1 -69 9 -13 32 -29 50 -37 26 -11 34 -20 34 -39 0 -16 6 -25 15 -25 9
      0 15 9 15 25 0 19 8 28 35 39 46 20 72 71 59 118 -7 25 -19 38 -51 53 l-42 20
      -1 68 c0 50 3 67 13 67 17 0 43 -28 51 -57 8 -26 24 -30 32 -9 9 25 -26 77
      -62 92 -26 11 -34 20 -34 39 0 16 -6 25 -15 25 -9 0 -15 -9 -15 -25z m0 -123
      c0 -67 -5 -76 -34 -60 -42 22 -48 59 -14 95 36 39 48 30 48 -35z m68 -128 c27
      -18 30 -69 5 -96 -32 -35 -43 -23 -43 47 0 36 3 65 8 65 4 0 18 -7 30 -16z"/>
        </g>
      </svg>
    ),
  },
  {
    id: 6,
    title: "Audit Trails & Deployment History",
    description: "Track logs, deployments, and audit events for maximum transparency and operational traceability.",
    icon: (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="30px" height="30px" viewBox="0 0 118.000000 118.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,118.000000) scale(0.100000,-0.100000)"
          fill="#FFFFFF" stroke="none">
          <path d="M75 1106 l-25 -25 0 -394 c0 -315 3 -397 13 -406 34 -28 37 5 37 406
      l0 393 301 0 301 0 -41 -47 c-26 -28 -47 -66 -57 -99 l-15 -53 -82 -3 c-65 -2
      -82 -6 -82 -18 0 -12 17 -16 82 -18 l82 -3 16 -56 c21 -70 100 -155 163 -174
      l42 -12 0 -249 0 -248 -355 0 -355 0 0 23 c0 31 -15 51 -34 44 -25 -10 -20
      -64 9 -92 l24 -25 356 0 356 0 24 25 25 24 0 244 0 245 38 7 c142 26 246 160
      228 292 -10 78 -71 183 -106 183 -23 0 -22 -32 3 -58 54 -56 74 -163 43 -236
      -69 -164 -294 -185 -393 -35 -57 86 -39 216 39 284 64 54 115 64 243 43 14 -2
      20 3 20 17 0 38 -55 43 -478 44 l-398 1 -24 -24z"/>
          <path d="M840 960 c0 -84 -2 -92 -31 -134 -30 -41 -34 -76 -10 -76 5 0 25 22
      45 49 36 48 36 50 36 150 0 94 -1 101 -20 101 -19 0 -20 -7 -20 -90z"/>
          <path d="M215 948 c-30 -17 -35 -28 -35 -89 0 -73 17 -89 91 -89 60 0 71 5 88
      37 25 49 7 123 -36 142 -31 14 -82 14 -108 -1z m100 -88 l0 -45 -45 0 c-44 0
      -45 1 -48 33 -5 54 2 64 50 60 l43 -3 0 -45z"/>
          <path d="M230 683 c-38 -14 -50 -36 -50 -93 0 -64 15 -86 67 -96 91 -18 151
      63 112 150 -17 36 -83 56 -129 39z m85 -93 l0 -45 -45 0 c-44 0 -45 1 -48 33
      -5 54 2 64 50 60 l43 -3 0 -45z"/>
          <path d="M425 600 c-11 -19 6 -30 46 -30 32 0 39 3 39 20 0 17 -7 20 -39 20
      -22 0 -43 -4 -46 -10z"/>
          <path d="M545 599 c-14 -22 14 -30 101 -27 71 2 89 6 89 18 0 12 -18 16 -92
      18 -60 2 -94 -1 -98 -9z"/>
          <path d="M197 392 c-18 -19 -24 -116 -9 -138 21 -32 90 -44 135 -23 43 19 61
      93 36 142 -17 32 -28 37 -90 37 -42 0 -60 -5 -72 -18z m118 -72 l0 -45 -45 0
      c-44 0 -45 1 -48 33 -5 54 2 64 50 60 l43 -3 0 -45z"/>
          <path d="M425 329 c-15 -24 17 -29 161 -27 125 3 149 5 149 18 0 13 -25 15
      -152 18 -103 2 -154 -1 -158 -9z"/>
          <path d="M55 230 c-8 -13 3 -30 20 -30 14 0 27 24 18 34 -10 9 -31 7 -38 -4z" />
        </g>
      </svg>
    ),
  },
];
const Features = () => {
  const [selectedFeature, setSelectedFeature] = useState(null);

  useEffect(() => {
    // Initialize with first feature selected after a slight delay for animation
    const timer = setTimeout(() => {
      setSelectedFeature(1);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Handle scroll reveal animations
  useEffect(() => {
    const revealElements = document.querySelectorAll('.reveal');

    const revealOnScroll = () => {
      for (let i = 0; i < revealElements.length; i++) {
        const windowHeight = window.innerHeight;
        const elementTop = revealElements[i].getBoundingClientRect().top;
        const elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          revealElements[i].classList.add('active');
        }
      }
    };

    window.addEventListener('scroll', revealOnScroll);
    // Initial check
    revealOnScroll();

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  // Fixed handler to prevent deselection when clicking the same feature
  const handleFeatureClick = (featureId) => {
    setSelectedFeature(featureId);
  };

  return (
    <section id="features" className="py-24 relative overflow-hidden bg-gradient-to-b from-black via-indigo-900/50 to-indigo-900">
      <div className="container px-4 mx-auto relative z-10">
        {/* Section heading */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="section-heading reveal fade-bottom">
            Design, deploy, control your cloud infrastructure
          </h2>
          <p className="section-subheading reveal fade-bottom">
            Cloudima enables teams to visually create architectures, instantly generate Terraform code, and deploy with precision, ensuring standardization across multiple clouds.
          </p>
        </div>

        {/* Features grid/interactive display */}
        <div className="grid md:grid-cols-3 gap-10">
          {/* Left Column */}
          <div className="space-y-6 md:col-span-1">
            {featuresData.slice(0, 3).map((feature) => (
              <div
                key={feature.id}
                className={`feature-card cursor-pointer ${selectedFeature === feature.id ? 'ring-2 ring-cloudima-blue scale-105' : 'hover:scale-105'}`}
                onClick={() => handleFeatureClick(feature.id)}
              >
                <div className="flex items-start gap-4">
                  <div className={`p-2 rounded-lg ${selectedFeature === feature.id ? 'bg-cloudima-blue text-white' : 'bg-cloudima-grey text-cloudima-blue'}`}>
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">{feature.title}</h3>
                    <p className="text-sm text-muted-foreground">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Middle Column - Feature Visualization */}
          <div className="md:col-span-1 flex items-center justify-center reveal fade-bottom">
            <div className="relative aspect-square w-full max-w-sm">
              {/* Main circle */}
              <div className="absolute inset-0 rounded-full border-2 border-dashed border-cloudima-blue/40 animate-pulse-slow">
                <div className="absolute inset-2 rounded-full border border-cloudima-blue/20"></div>
                <div className="absolute inset-4 rounded-full border border-cloudima-blue/10"></div>
              </div>

              {/* Center icon */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-32 h-32 rounded-full bg-white shadow-xl flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-16 h-16 text-cloudima-blue">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                  </svg>
                </div>
              </div>

              {/* Floating elements */}
              <div className="absolute top-6 left-6 w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center animate-float">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-purple-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
                </svg>
              </div>
              <div className="absolute bottom-6 left-6 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center animate-float animation-delay-1000">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-blue-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" />
                </svg>
              </div>
              <div className="absolute top-6 right-6 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center animate-float animation-delay-2000">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-green-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.746 3.746 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
                </svg>
              </div>
              <div className="absolute bottom-6 right-6 w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center animate-float animation-delay-3000">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-amber-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-6 md:col-span-1">
            {featuresData.slice(3).map((feature) => (
              <div
                key={feature.id}
                className={`feature-card cursor-pointer ${selectedFeature === feature.id ? 'ring-2 ring-cloudima-blue scale-105' : 'hover:scale-105'}`}
                onClick={() => handleFeatureClick(feature.id)}
              >
                <div className="flex items-start gap-4">
                  <div className={`p-2 rounded-lg ${selectedFeature === feature.id ? 'bg-cloudima-blue text-white' : 'bg-cloudima-grey text-cloudima-blue'}`}>
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">{feature.title}</h3>
                    <p className="text-sm text-muted-foreground">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
